<!--
 * @Description: 微信验证
 * @Author: xu wei
 * @Date: 2020-03-07 15:43:10
 * @LastEditTime: 2020-07-28 16:35:02
 * @LastEditors: gao shuai
 -->
<template>
  <div class="partinstall">
    <div class="bg_fff">
      <div class="gs_listcontainer">
        <p class="tip_red">微信验证</p>
      </div>
      <div class="mgl15 mgr15 pdb15">
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane label="公众号设置" name="first">
            <p>
              支持：GOM、GEE、新BLUE、GOB引擎，<font color="#008000"
                >安装请观看视频教程。</font
              >
            </p>
            <p class="mgt5">
              注意：<font color="#0000FF"
                >平台公众号用于平台绑定验证和菜单操作，平台公众号菜单若提示无权限，请至用户个人中心对菜单自主选择需要授权的菜单</font
              >
            </p>
            <p class="mgt5">
              注意：<font color="#0000FF"
                >用于密保验证推荐使用平台公众号或自己的公众号：下面是1分种快速注册自己公众号方法</font
              >
            </p>
             <p class="mgt5">
              注意：<font color="#0000FF"
                >平台公众号若提示未开通请联系平台QQ200536001开通平台密保验证功能</font
              >
            </p>
            <p class="mgt5">
                   ==1：<font color="#0000FF"
                    >下载订阅号助手APP快速注册公众号</font
              >
            </p>
            <p class="mgt5">
                   ==2：<font color="#0000FF"
                    >登录mp.weixin.qq.com配置下面公众号需要的内容</font
              >
            </p>
            <el-divider></el-divider>
            <el-form ref="form" :model="form" label-width="160px">
              <el-form-item label="功能状态：">
                <span v-if="isEnabledWxValid">已开通</span>
                <span v-else>未开通</span>
              </el-form-item>
              <el-form-item label="公众号：">
                <el-radio-group v-model="form.isOwnAccount">
                  <el-radio :label="false" :disabled="!isPlatOpenWxValid"
                    >平台公众号<font color="#FF0000" v-if="!isPlatOpenWxValid"
                      >(未开通)</font
                    >
                  </el-radio>
                  <el-radio :label="true">自己公众号</el-radio>
                </el-radio-group>
              </el-form-item>
               <div  v-if="form.isPlatOpenWxValid && !form.isOwnAccount" class="tc pdt20 pdb25">
        <img style="width:200px;height:200px;" :src="wxQrStr" alt="">      
        <p class="mgt5"><span>请保存微信二维码，并配置到游戏中</span></p>
      </div>
              <div v-if="form.isOwnAccount && isEnabledWxValid">
                <el-form-item label="查看消息关键字：">
                  <el-row :gutter="10">
                    <el-col :span="4">
                      <el-input
                        size="small"
                        v-model="form.messageKeyword"
                      ></el-input>
                    </el-col>
                    <el-col :span="16"
                      >非认证号,请玩家输入<font color="#ff0000">1</font
                      >,获取验证码</el-col
                    >
                  </el-row>
                </el-form-item>
                <el-form-item label="公众号类型：">
                  <el-radio-group v-model="form.weChatAccountType">
                    <el-radio :label="0">订阅号 </el-radio>
                    <el-radio :label="1">服务号</el-radio>
                    <el-radio :label="2">认证服务号</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="公众号Appid：">
                  <el-row>
                    <el-col :span="10">
                      <el-input size="small" v-model="form.appId"></el-input>
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item label="公众号Secret：">
                  <el-row>
                    <el-col :span="10">
                      <el-input
                        size="small"
                        v-model="form.appSecret"
                      ></el-input>
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item label="配置URL：">
                  <el-row>
                    <el-col :span="10">
                      <el-input
                        size="small"
                        v-model="form.configUrl"
                        disabled
                      ></el-input>
                    </el-col>
                    <el-col :span="12">
                      <font color="#ff0000">
                        点保存后生成URL，请复制到公众号开发=>基本配置=>服务器地址(URL)</font
                      >
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item label="通讯token：">
                  <el-row>
                    <el-col :span="10">
                      <el-input
                        size="small"
                        v-model="form.communicationToken"
                      ></el-input>
                    </el-col>
                    <el-col :span="2">
                      <el-button
                        size="small"
                        type="primary"
                        style="margin-left: 10px"
                        @click="token"
                        >生成token</el-button
                      >
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item label="消息加解密密钥：">
                  <el-row>
                    <el-col :span="10">
                      <el-input
                        size="small"
                        v-model="form.messageEncryptKey"
                      ></el-input>
                    </el-col>
                    <el-col :span="2">
                      <el-button
                        size="small"
                        type="primary"
                        style="margin-left: 10px"
                        @click="random"
                        >随机生成</el-button
                      >
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item label="消息加解密方式：">
                  <el-radio-group v-model="form.wxEncryptionType">
                    <el-radio :label="0">明文模式 </el-radio>
                    <el-radio :label="1">兼容模式</el-radio>
                    <el-radio :label="2">安全模式（推荐）</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="被关注回复：">
                  <el-row>
                    <el-col :span="10">
                      <el-input
                        size="small"
                        v-model="form.beConcernedReply"
                        placeholder="如:欢迎关注XX公众号"
                      ></el-input>
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item label="验证码模板ID：">
                  <el-row>
                    <el-col :span="10">
                      <el-input
                        size="small"
                        v-model="form.templateId"
                        placeholder="验证码模板ID"
                      ></el-input>
                    </el-col>
                  </el-row>
                </el-form-item>
              </div>
              <el-form-item label="">
                <el-button type="danger" size="small" @click="saveConfig"
                  >确认保存</el-button
                >
              </el-form-item>
              <el-form-item label="脚本下载：">
                <a
                  href="http://manageserver.231pay.com/api/Upload/ShowFileNew?name=GOM"
                  target="_blank"
                  >GOM/GEE脚本</a
                ><br />
                <a
                  href=" http://manageserver.231pay.com/api/Upload/ShowFileNew?name=新Blue"
                  target="_blank"
                  >新BLUE/GOB脚本</a
                >
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="自定义回复" name="second">
            <el-form ref="replay" :model="replay" label-width="160px">
              <el-form-item label="">
                多个关键字请用半角逗号<font color="#ff0000">,</font>分隔
              </el-form-item>
              <el-form-item label="关键字1：">
                <el-row>
                  <el-col :span="10">
                    <el-input
                      v-model="replay.key"
                      size="small"
                      type="textarea"
                      placeholder="如：官网,网站,网址,客服,群"
                    ></el-input>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item label="回复内容1：">
                <el-row>
                  <el-col :span="10">
                    <el-input
                      v-model="replay.reply"
                      size="small"
                      type="textarea"
                      placeholder="如：你好，我们的网站是：www.qq.com，QQ群是：123456"
                    ></el-input>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item label="关键字2：">
                <el-row>
                  <el-col :span="10">
                    <el-input
                      v-model="replay.key1"
                      size="small"
                      type="textarea"
                      placeholder="如：官网,网站,网址,客服,群"
                    ></el-input>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item label="回复内容2：">
                <el-row>
                  <el-col :span="10">
                    <el-input
                      v-model="replay.reply1"
                      size="small"
                      type="textarea"
                      placeholder="如：你好，我们的网站是：www.qq.com，QQ群是：123456"
                    ></el-input>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item label="关键字3：">
                <el-row>
                  <el-col :span="10">
                    <el-input
                      v-model="replay.key2"
                      size="small"
                      type="textarea"
                      placeholder="如：官网,网站,网址,客服,群"
                    ></el-input>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item label="回复内容3：">
                <el-row>
                  <el-col :span="10">
                    <el-input
                      v-model="replay.reply2"
                      size="small"
                      type="textarea"
                      placeholder="如：你好，我们的网站是：www.qq.com，QQ群是：123456"
                    ></el-input>
                  </el-col>
                </el-row>
              </el-form-item>
              <!-- <el-form-item label="其它回复：">
                <el-row>
                  <el-col :span="10">
                    <el-input
                      size="small"
                      v-model="replay.weChatAccountId"
                      type="textarea"
                      placeholder="如：你好，有什么问题请联系QQ：456789"
                    >
                    </el-input>
                  </el-col>
                </el-row>
              </el-form-item> -->
              <el-form-item label="">
                <el-button type="danger" size="small" @click="saveReplay"
                  >确认保存</el-button
                >
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="查看验证码" name="third">
            <div>
              功能介绍：本页面提供查看未过期的验证码，GM可以使用玩家对应验证码登陆游戏
              <el-button
                type="primary"
                size="small"
                style="margin-left: 10px"
                @click="refresh"
                >刷新</el-button
              >
            </div>
            <el-divider></el-divider>
            <el-table
              ref="singleTable"
              :data="tableData"
              highlight-current-row
              border
              :header-cell-style="{ background: '#F2F2F2', color: '#606266' }"
              class="mgt15"
            >
              <el-table-column
                property="partitionName"
                label="分区名称"
                align="center"
              >
               
              </el-table-column>
              <el-table-column
                property="roleName"
                label="角色名称"
                align="center"
              >
              </el-table-column>
              <el-table-column
                property="validateCode"
                label="验证码"
                align="center"
              >
              </el-table-column>
              <el-table-column
                property="validateCodeType"
                label="验证类型"
                align="center"
              >
              </el-table-column>
              <el-table-column
                property="remainingTime"
                label="剩余有效时间（秒）"
                align="center"
              >
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import mgr from "../../assets/js/securityapi";
import api from "../../assets/js/apiRequestHandler";
export default {
  data() {
    return {
      activeName: "first",
      isEnabledWxValid: false,
      isPlatOpenWxValid: false,
      wxQrStr: '',
      form: {
        id: 0,
        applicationUserId: 0,
        isOwnAccount: false,
        messageKeyword: "",
        appId: "",
        appSecret: "",
        configUrl: "",
        communicationToken: "",
        wxEncryptionType: 2,
        beConcernedReply: "",
        weChatAccountType: 0,
        templateId: "",
      },
      replay: {
        id: 0,
        key: "",
        key1: "",
        key2: "",
        reply: "",
        reply1: "",
        reply2: "",
        weChatAccountId: 0,
      },

      value: false,
      tableData: [],
    };
  },
  created() {
    this.getDetail();
    this.getReplay();
    this.getLists();
  },
  methods: {
    refresh() {
      this.getLists();
    },
    async getLists() {
      let header = await mgr();
      api
        .get("/api/WxValid/GetWxValidCodes", {
          headers: {
            Authorization: "Bearer " + header,
          },
        })
        .then((res) => {
          console.log(res.data);
          this.tableData = res.data;
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    async getReplay() {
      let header = await mgr();
      api
        .get("/api/WxValid/GetWxCustomReplies", {
          headers: {
            Authorization: "Bearer " + header,
          },
        })
        .then((res) => {
          if(res.data===undefined || res.data === '' || res.data === null)
          return;
          //console.log(res.data);
          this.replay = res.data;
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    async getDetail() {
      let header = await mgr();
      api
        .get("/api/WxValid/GetWxValidInfo", {
          headers: {
            Authorization: "Bearer " + header,
          },
        })
        .then((res) => {
          console.log(res.data);
          this.form = res.data;
          this.isEnabledWxValid = res.data.isEnabledWxValid;
          this.isPlatOpenWxValid = res.data.isPlatOpenWxValid;
          this.wxQrStr = res.data.wxQrStr;
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    async saveReplay() {
      let header = await mgr();
      api
        .post("/api/WxValid/AddOrUpdateWxCustomReplies", this.replay, {
          headers: {
            Authorization: "Bearer " + header,
          },
        })
        .then((res) => {
          console.log(res.data);
          this.$messageSuccess("操作成功");
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    async saveConfig() {
      let header = await mgr();
      this.form.applicationUserId = this.$store.state.id;
      api
        .post("/api/WxValid/AddOrUpdateWxValid", this.form, {
          headers: {
            Authorization: "Bearer " + header,
          },
        })
        .then((res) => {
          console.log(res.data);
          this.$messageSuccess("操作成功");
          this.form.configUrl = res.data;
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    token() {
      this.form.communicationToken = this.randam(32);
    },
    random() {
      this.form.messageEncryptKey = this.randam(43);
    },
    randam(size) {
      var arr = [];
      for (let i = 65; i <= 90; i++) {
        arr.push(String.fromCharCode(i));
      }
      for (let i = 97; i <= 122; i++) {
        arr.push(String.fromCharCode(i));
      }
      for (let i = 0; i <= 9; i++) {
        arr.push(i);
      }
      var str = "";
      for (let x = 1; x <= size; x++) {
        var index = Math.floor(Math.random() * arr.length);
        str += arr[index];
      }
      return str;
    },
  },

  destroyed() {},
};
</script>

<style lang="scss" scoped>
.tip_red {
  color: #3c8dbc;
  padding: 10px 0px;
  font-weight: bold;
  font-size: 15px;
}

.gs_listcontainer {
  padding-top: 0;
  padding-bottom: 15px;
  margin-left: 20px;

  .clearfix {
    border: 1px solid #d9edf7;
    width: 95%;
    margin-bottom: 1px;
    padding-left: 0px;
    box-sizing: border-box;

    .mgl20 {
      float: right;
    }

    dt {
      background-color: #d9edf7;
      padding-right: 10px;
    }

    dd {
      padding-top: 5px;
    }
  }
}

.mg2 {
  float: right;
  margin-top: -20px;
}

.opeartbox {
  border: 1px solid #00bcd4;
  width: 97%;
}

.line_tip {
  color: #999;
  font-size: 14px;
  margin-left: 20px;
}

.right {
  float: right;
  margin-right: 4%;
}

.el-form-item {
  margin-bottom: 10px;
}

.editserverBox {
  padding-left: 20px;

  .list {
    margin-bottom: 10px;

    .tit {
      float: left;
      width: 90px;
      height: 32px;
      line-height: 32px;
    }

    .content {
      float: left;
      width: 250px;
    }
  }

  .serveList {
    li {
      position: relative;
      float: left;
      width: 100px;
      text-align: center;
      border: 1px solid #ccc;
      border-radius: 4px;
      margin-right: 15px;
      margin-bottom: 10px;
      overflow: hidden;

      .tit {
        background: #3c8dbc;
        color: #fff;
        height: 22px;
        line-height: 22px;
      }

      .numberbox {
        height: 25px;
        line-height: 25px;
        color: green;
        font-size: 13px;
      }

      &:hover {
        .mask {
          top: 0;
        }
      }

      .mask {
        position: absolute;
        transition: top 0.3s;
        top: 100%;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.8);
        color: #fff;
        cursor: pointer;
        line-height: 50px;
      }
    }
  }
}

.passwordBox {
  padding-left: 20px;
  display: flex;
  flex-flow: row nowrap;
  padding-bottom: 16px;

  .tit {
    display: block;
    width: 100px;
    height: 32px;
    line-height: 32px;
  }
}

.bindwei {
  width: 95%;
  border: 1px solid #d9edf7;

  .tit {
    width: 100px;
    background: #d9edf7;
    padding-right: 10px;
    font-size: 14px;
    text-align: right;
    color: #333;
  }

  .el-tag {
    margin: 5px 10px 5px 0;
  }
}

.weixinbox {
  margin-left: 20px;

  .clearfix1:after {
    content: "";
    display: table;
    clear: both;
    border-spacing: 0;
  }

  table {
    width: 95%;
    margin-top: -10px;
    border-collapse: separate;
    border-spacing: 0 10px;

    tr {
      td {
        border: 1px solid #d9edf7;

        ul {
          margin: 0 100px 0 70px;

          li {
            float: left;
            margin-right: 60px;

            .tit {
              float: left;
              height: 40px;
              line-height: 40px;
              font-size: 13px;
              width: 90px;
              text-align: right;
              color: #313131;
            }

            .contbox {
              float: left;
              margin-top: 7px;
              margin-left: 20px;
            }
          }
        }
      }

      .tit_td {
        width: 98px;
        background: #d9edf7;
        padding-right: 10px;
        text-align: right;
        font-size: 14px;
        color: #333;
      }
    }
  }
}

.authority {
  position: absolute;
  font-size: 14px;
  right: 10px;
  top: 12px;
  color: #63aafa;
  cursor: pointer;
}
</style>
